import { defineComponent, ref, computed, watch, nextTick, onMounted, onUnmounted } from "vue";
import uniqueId from "./component-library250.mjs";
import { directive as directive_1 } from "./component-library256.mjs";
import Arrow from "./component-library4.mjs";
import LinkButton from "./component-library3.mjs";
import useDropdown from "./component-library86.mjs";
import DropdownContainer from "./component-library73.mjs";
import throttle from "./component-library147.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "dropdown",
  props: {
    caption: { default: "" },
    opened: { type: Boolean },
    disabled: { type: Boolean },
    autoWidth: { type: Boolean }
  },
  emits: ["focus", "toggle", "close"],
  setup(__props, { expose, emit }) {
    const props = __props;
    const uid = ref(uniqueId());
    const showRight = ref(false);
    const buttonElement = ref(null);
    const dropdownContainerElement = ref(null);
    const openable = useDropdown(dropdownContainerElement, {
      focusFirstOnOpen: true,
      focusOnArrowKeys: true
    });
    openable.onClose.value = () => {
      var _a;
      emit("close");
      if (!((_a = buttonElement.value) == null ? void 0 : _a.$el))
        return;
      buttonElement.value.$el.focus();
    };
    const containerClass = computed(() => ({
      "dropdown--open": openable.isOpened.value
    }));
    watch(
      () => props.opened,
      (isOpened) => {
        openable.isOpened.value = isOpened || false;
      }
    );
    watch(
      () => props.disabled,
      (val, wasVal) => {
        if (val !== wasVal && !val) {
          openable.isOpened.value = false;
        }
      },
      { immediate: true }
    );
    const resizeHandler = () => {
      var _a;
      if (!((_a = dropdownContainerElement.value) == null ? void 0 : _a.$el))
        return;
      const boundings = dropdownContainerElement.value.$el.getBoundingClientRect();
      const windowWidth = window.document.body.offsetWidth;
      if (windowWidth < boundings.width) {
        showRight.value = false;
        return;
      }
      if (showRight.value) {
        showRight.value = windowWidth - boundings.right < 200;
      } else {
        showRight.value = boundings.right > windowWidth;
      }
    };
    const throttledResizeHandler = throttle(resizeHandler, 250);
    watch(openable.isOpened, (val) => {
      emit("toggle", val);
      if (!val) {
        window.removeEventListener("resize", throttledResizeHandler);
        return;
      }
      window.addEventListener("resize", throttledResizeHandler);
      nextTick(() => {
        resizeHandler();
      });
    });
    onMounted(() => {
      if (props.opened) {
        openable.isOpened.value = true;
      }
    });
    onUnmounted(() => {
      window.removeEventListener("resize", throttledResizeHandler);
    });
    openable.onEsc.value = () => {
      var _a, _b;
      (_b = (_a = buttonElement.value) == null ? void 0 : _a.$el) == null ? void 0 : _b.focus();
      emit("focus");
    };
    expose({
      open: () => {
        openable.isOpened.value = true;
      },
      close: () => {
        openable.isOpened.value = false;
      },
      openable
    });
    return { __sfc: true, props, uid, showRight, buttonElement, dropdownContainerElement, openable, emit, containerClass, resizeHandler, throttledResizeHandler, vOnClickaway: directive_1, Arrow, LinkButton, DropdownContainer };
  }
});
export {
  _sfc_main as default
};
